import React from 'react';
import './HomepageTable.scss';
import { EventDTO } from '../../../models/common/EventDTO';
import moment from 'moment';
import {
  arr,
  EmptyOddsBlock,
  getOdds,
  teamTypes,
} from '../../../components/ExchEventsTable/ExchInplayEventsTable';
import OddButton from '../../../components/ExchOddButton/ExchOddButton';
import {
  liveImagesMap,
  SportIconMap,
  SportIconMapInplay,
  SportIdByName,
  SportIdByNameMap,
} from '../../../util/stringUtil';
import { useHistory } from 'react-router';
import rightArrow from '../../../assets/images/home/right-arrow-black.svg';
import { getSportLangKeyByName } from '../../../util/localizationUtil';
import { useSelector } from 'react-redux';
import { RootState } from '../../../models/RootState';
import { Button } from '@material-ui/core';

type InplayEventsObj = {
  sportId: string;
  sportName: string;
  sportSlug: string;
  events: EventDTO[];
};

interface HomepageTableProps {
  event: any;
  selectedSport: any;
}

const HomepageTableMob: React.FC<HomepageTableProps> = ({ event, selectedSport }) => {
  const history = useHistory();
  const eventList = event;
  const langData = useSelector((state: RootState) => state.common.langData);
 
  const handleEventChange = (iEvent: InplayEventsObj, event: EventDTO) => {
    const competitionSlug = event.competitionName
      ? event.competitionName
          .toLocaleLowerCase()
          .replace(/[^a-z0-9]/g, ' ')
          .replace(/ +/g, ' ')
          .trim()
          .split(' ')
          .join('-')
      : 'league';
    history.push(
      `/exchange_sports/${iEvent.sportSlug}/${competitionSlug}/${
        event.eventSlug
      }/${btoa(`${event.sportId}:${event.competitionId}:${event.eventId}`)}`
    );
  };

  const handleViewAll = (sportName) => {
    history.push(`exchange_sports/${sportName.toLowerCase()}`);
  };

  return (
    <>
      
      <div className="table-container">
        <div className="mob-table-title-ctn">
          <div className="sportndname">
            <img
              className="sport-inplay-icon"
              src={SportIconMapInplay[selectedSport.id]}
              alt={selectedSport.name + ' icon'}
            />
            {langData?.[`${getSportLangKeyByName(selectedSport.name)}`]}
          </div>
          <div className="button-viewall">
            <Button
              className="viewall-btn"
              onClick={() => handleViewAll(selectedSport.name)}
            >
              {langData?.['view_all']}
            </Button>
          </div>
        </div>

        <div className="mob-table-rows-ctn">
          {eventList &&
            eventList.length > 0 &&
            eventList.slice(0, 3).map(
              (
                eventObj,
                index // Slice the eventList to show only 3 events
              ) => (
                <div
                  onClick={() => handleEventChange(event, eventObj)}
                  className="mob-table-row"
                  key={eventObj.eventId}
                >
                  <div className="table-date-ctn">
                    <div className="event-info-ctn">
                      <div>
                        <div className="eventsandblinking">
                          <div className={eventObj.status == 'IN_PLAY' ? "green-circle" : ""}></div>
                          <div className="mob-event-title">
                            {' '}
                            {eventObj.eventName}
                          </div>
                        </div>
                        <div className="event-date-ctn">
                          <img
                            className="live-img"
                            src={eventObj.status == 'IN_PLAY' ? liveImagesMap[selectedSport.id] : ''}
                            alt=""
                          />
                          <div className="date-txt">
                            {moment(eventObj?.openDate).format('HH:mm')} |{' '}
                            {moment(eventObj?.openDate).format('DD MMM')}
                          </div>
                        </div>
                      </div>
                      <div className="action-btns-ctn">
                        <div className="custom-button-ctn">
                          {eventObj.enablePremium && (
                            <button key={'P'} className="custom-button">
                              {'P'}
                            </button>
                          )}
                          {eventObj.enablePremium && (
                            <button key={'MO'} className="custom-button">
                              {'MO'}
                            </button>
                          )}

                          {eventObj.enableBookmaker && (
                            <button key={'B'} className="custom-button">
                              {'B'}
                            </button>
                          )}
                          {eventObj.enableFancy && (
                            <button key={'F'} className="custom-button">
                              {'F'}
                            </button>
                          )}
                        </div>
                        <div>
                          <img src={rightArrow} alt="rightArrow" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="odds-ctn">
                    {teamTypes.map((teamType, index) => (
                      <div className="odd-section" key={teamType}>
                        {eventObj?.matchOdds ? (
                          getOdds(eventObj, teamType) ? (
                            <div className="odds-block-mob">
                              {getOdds(eventObj, teamType).map((odd) => (
                                <div
                                  className={`odds-cell-common-mob ${
                                    odd.type === 'back-odd'
                                      ? `back-odd-cell ${
                                          +odd.price > 0 ? '' : 'disabled'
                                        }`
                                      : `lay-odd-cell ${
                                          +odd.price > 0 ? '' : 'disabled'
                                        }`
                                  }`}
                                  key={odd.price} // Key added for each odd item
                                >
                                  <OddButton
                                    mainValue={odd.price}
                                    subValue={odd.size}
                                    oddType={
                                      odd.type === 'back-odd'
                                        ? 'back-odd'
                                        : 'lay-odd'
                                    }
                                    disable={eventObj.matchOdds.status
                                      .toLowerCase()
                                      .includes('suspended')}
                                    valueType="matchOdds"
                                    showSubValueinKformat={true}
                                    onClick={() => null}
                                    subValueClass={'size'}
                                  />
                                </div>
                              ))}
                            </div>
                          ) : (
                            <EmptyOddsBlock />
                          )
                        ) : (
                          <EmptyOddsBlock />
                        )}
                      </div>
                    ))}
                  </div>

                  {index < eventList.slice(0, 3).length - 1 && ( // Only show separator for the first 2 events
                    <div className="event-block-separator" />
                  )}
                </div>
              )
            )}
        </div>
      </div>
    </>
  );
};

export default HomepageTableMob;
